let routes = [
  //易纸箱的购买入口
  {
    path: '/yzxBuyEntrance',
    name: 'yzxBuyEntrance',
    component: () => import('@/views/yzxBuyEntrance/index.vue')
  }
]

export default routes
